import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from './translate.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {

  /**
   * Constructor
   * @param translate
   * TranslateService to translate phrases.
   */
  constructor(private translate: TranslateService) {
  }

  /**
   * Pipe-method.
   * @param value
   * The value to be translated.
   * @param args
   * Interface relict.
   */
  transform(value: string, args?: any): string {
    return this.translate.translate(value);
  }

}
